<template>
    <div id="beneficial-owners" class="container-fluid">
        <div class="row contextual-data" v-if="false">
            <div class="col-md-12">
                <span class="pull-right">
                    <strong>Statut RBE :</strong> {{ customer.decoded_rbe_status }}
                </span>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <beneficial-owners-declaration
                    :customer-id="customerId"
                >
                </beneficial-owners-declaration>
            </div>
            
            <div class="col-md-6">
                <inpi-rbe-documents 
                    :declaration-id="declarationId"
                >
                </inpi-rbe-documents>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <beneficial-owners-list
                    :declaration-id="declarationId"
                >
                </beneficial-owners-list>
            </div>
        </div>

        <div class="row m-t-20 contextual-data" v-if="false">
            <div class="col-md-12"
                v-if="lastActivity"
            >
                <div class="pull-right">
                    <span>
                        Dernière mise à jour de la fiche le {{ lastActivity.created_at | moment-date }}
                    </span>

                    <span v-if="lastActivity.user">
                        par {{ lastActivity.user.email }}
                    </span>
                </div>
            </div>
            
            <div class="col-md-12"
                v-if="lastDocumentsGathering"
            >
                <div class="pull-right">
                    <span>
                        Dernière demande INPI en masse le {{ lastDocumentsGathering.created_at | moment-date }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
    import {mapState, mapActions} from "vuex"
    import BeneficialOwnersDeclaration from 'components/BeneficialOwners/BeneficialOwnersDeclaration'
    import InpiRbeDocuments from 'components/BeneficialOwners/InpiRbeDocuments'
    import BeneficialOwnersList from 'components/BeneficialOwners/BeneficialOwnersList'
    
    export default {
        name: "BeneficialOwners",

        props: {
            specifiedCustomerId: {
                type: Number,
                default: null
            }
        },

        components: {
            BeneficialOwnersDeclaration,
            InpiRbeDocuments,
            BeneficialOwnersList
        },

        data() {
            return {
                customerId: null
            }
        },

        created() {
            // If no specific customer ID has been provided as a prop, we use the store
            this.customerId = this.specifiedCustomerId ? this.specifiedCustomerId : this.customer.id
        },

        computed:{
            ...mapState('demands', ['current_demands']),
            ...mapState('beneficialOwners', ['declaration']),

            currentDemand () {
                return (_.find(this.current_demands, (demand) => demand.id == this.$route.params.id))
            },

            customer() {
                return this.currentDemand ? this.currentDemand.customer : null
            },

            declarationId() {
                return this.declaration ? this.declaration.id : null
            },

            lastActivity() {
                if (this.declaration && this.declaration.activity_log) {
                    const filteredActivities = _.filter(this.declaration.activity_log, function(a) { return 'inpi-documents-gathering' != a.type })
                    const orderedActivities = _.orderBy(filteredActivities, 'created_at', 'desc')

                    return orderedActivities[0]
                }

                return null
            },

            lastDocumentsGathering() {
                if (this.declaration && this.declaration.activity_log) {
                    const filteredActivities = _.filter(this.declaration.activity_log, function(a) { return 'inpi-documents-gathering' == a.type })
                    const orderedActivities = _.orderBy(filteredActivities, 'created_at', 'desc')

                    return orderedActivities[0]
                }

                return null
            }
        }
    }
</script>

<style lang="scss" scoped>
    #beneficial-owners {
        padding: 0!important;
        position: relative;

        .overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(235, 235, 235, 0.5);

            .progress-circle-indeterminate {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                width: 30px;
                height: 30px;
            }
        }

        .contextual-data {
            font-size: 16px;
        }
    }
</style>



// WEBPACK FOOTER //
// client/components/Demands/BeneficialOwners.vue